import { createEmsAuth, type EmsAuthClient } from '@chopchop-se/ems-auth';

import { env } from '../lib/env';

/**
 * The EMS SSO client (ARCHITECTURE §5). Redirect flow only:
 *
 *   /login          → `auth.login()` → EMS authorize → back to
 *   /auth/callback  → `tryHandleCallback()` → POST /api/auth/exchange
 *
 * The EMS JWT lives for the duration of that POST and is then DROPPED. It is
 * never written to localStorage/sessionStorage/a cookie — the old WMS kept it
 * in localStorage, which meant any XSS became a permanent estate-wide identity
 * leak. The only durable credential is the httpOnly session cookie pair the api
 * sets, which JavaScript cannot read.
 */

let client: EmsAuthClient | null = null;

export function emsAuth(): EmsAuthClient {
  if (!env.ems.configured) {
    throw new Error('EMS SSO is not configured (VITE_EMS_BASE_URL is empty).');
  }
  client ??= createEmsAuth({
    baseUrl: env.ems.baseUrl,
    systemCode: env.ems.systemCode,
    callbackUrl: env.ems.callbackUrl,
  });
  return client;
}

export function isSsoConfigured(): boolean {
  return env.ems.configured;
}

/** Test seam. */
export function __resetEmsAuth(): void {
  client = null;
}
